import { useAuthStore } from '@/store/auth';
import type { NavigationGuardNext, RouteLocationNormalized } from 'vue-router';

export function isProfileDisabled(to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) {
  const authStore = useAuthStore();
  if (authStore.isDisabled) {
    next('/disabled');
  } else {
    next();
  }
}
